import { createRouter, createWebHistory, RouteRecordRaw } from "vue-router";

import UsuariosIndex from "@/pages/Usuarios/Index.vue";
import UsuarioCadastro from "@/pages/Usuarios/UsuarioCadastro.vue";

import PlanosCadastro from "@/pages/Planos/Cadastro.vue";
import PlanosIndex from "@/pages/Planos/Index.vue";
import PlanosLer from "@/pages/Planos/Ler.vue";

import ClientesCadastro from "@/pages/Clientes/Cadastro.vue";
import ClientesIndex from "@/pages/Clientes/Index.vue";
import ClientesCartao from "@/pages/Clientes/CartaoPdf.vue";
import ValidadorIndex from "@/pages/Validador/Index.vue";

import TitularesIndex from "@/pages/Titulares/Index.vue";

import EmpresasCadastro from "@/pages/Empresas/Cadastro.vue";
import EmpresasIndex from "@/pages/Empresas/Index.vue";

import ParceirosCadastro from "@/pages/Parceiros/Cadastro.vue";
import ParceirosIndex from "@/pages/Parceiros/Index.vue";

import VouchersIndex from "@/pages/Vouchers/Index.vue";
import VouchersCadastro from "@/pages/Vouchers/Cadastro.vue";

import PermissoesIndex from "@/pages/Permissoes/Index.vue";
import LogsIndex from "@/pages/Logs/Index.vue";
import VersoesIndex from "@/pages/Versoes/Index.vue";

import Contratos from "@/pages/Contratos/Index.vue";
import ContratosCadastro from "@/pages/Contratos/Cadastro.vue";
import ContratosAssinar from "@/pages/Contratos/Assinar.vue";
import ContratosVer from "@/pages/Contratos/Ver.vue";

import ParametrosCadastro from "@/pages/Parametros/Cadastro.vue";
import ParametrosIndex from "@/pages/Parametros/Index.vue";

import BoletosConsultarBanco from "@/pages/Boletos/ConsultarBanco.vue";
import Boletos from "@/pages/Boletos/Index.vue";
import BoletosImportarRelatorioBanco from "@/pages/Boletos/ImportarRelatorioBanco.vue";
import BoletosRemessas from "@/pages/Boletos/Remessas.vue";
import BoletosRetornoItens from "@/pages/Boletos/RetornoItens.vue";
import BoletosRetornos from "@/pages/Boletos/Retornos.vue";

import EmailConfirmationPage from "../pages/Authentication/EmailConfirmationPage.vue";
import ForgotPasswordPage from "../pages/Authentication/ForgotPasswordPage.vue";
import LoginPage from "../pages/Authentication/LoginPage.vue";
import RegisterPage from "../pages/Authentication/RegisterPage.vue";
import ResetPasswordPage from "../pages/Authentication/ResetPasswordPage.vue";
import EcommercePage from "../pages/Dashboard/EcommercePage.vue";

import LogoutPage from "../pages/LogoutPage.vue";

import PainelCliente from "../cliente/Index.vue";
import PainelClienteLogin from "../cliente/Login.vue";
import PainelClienteParceiro from "../cliente/Parceiro.vue";
import PainelClienteVerContrato from "../cliente/VerContrato.vue";
import PainelClienteAssinarContrato from "../cliente/AssinarContrato.vue";

import RelMensalidades from "@/pages/Relatorios/Mensalidades.vue";
import RelClientes from "@/pages/Relatorios/Clientes/Index.vue";
import RelClientesContrato from "@/pages/Relatorios/ClientesContrato.vue";
import RelClientesDependentes from "@/pages/Relatorios/ClientesDependentes.vue";

import ErrorPage from "@/pages/ErrorPage.vue";
import Retornos from "@/pages/Boletos/Retornos.vue";
import RetornoItens from "@/pages/Boletos/RetornoItens.vue";
import RetornoDiferencas from "@/pages/Boletos/RetornoDiferencas.vue";

import ContasReceber from "@/pages/ContasReceber/Index.vue";



const routes: Array<RouteRecordRaw> = [
  {
    path: "/usuarios",
    name: "Usuarios",
    component: UsuariosIndex,
  },
  {
    path: "/usuarios/cadastro/:id?",
    name: "usuariosCadastro",
    component: UsuarioCadastro,
  },

  {
    path: "/planos",
    name: "Planos",
    component: PlanosIndex,
  },
  {
    path: "/planos/cadastro",
    name: "planosCadastro",
    component: PlanosCadastro,
  },
  {
    path: "/planos/cadastro/:id?",
    name: "planosCadastro",
    component: PlanosCadastro,
  },
  {
    path: "/planos/ler/:id",
    name: "planosLer",
    component: PlanosLer,
  },

  {
    path: "/clientes",
    name: "Clientes",
    component: ClientesIndex,
  },
  {
    path: "/clientes/cadastro/:id?",
    name: "clientesCadastro",
    component: ClientesCadastro,
  },
  {
    path: "/clientes/cartao/:id",
    name: "clientesCartao",
    component: ClientesCartao,
  },
  {
    path: "/validador/:id",
    name: "validador",
    component: ValidadorIndex,
  },

  {
    path: "/titulares",
    name: "titulares",
    component: TitularesIndex,
  },

  {
    path: "/empresas",
    name: "Empresas",
    component: EmpresasIndex,
  },
  {
    path: "/empresas/adicionar",
    name: "empresasAdicionar",
    component: EmpresasCadastro,
  },
  {
    path: "/empresas/alterar/:id",
    name: "empresasAlterar",
    component: EmpresasCadastro,
  },

  {
    path: "/parceiros",
    name: "Parceiros",
    component: ParceirosIndex,
  },
  {
    path: "/parceiros/adicionar",
    name: "parceirosAdicionar",
    component: ParceirosCadastro,
  },
  {
    path: "/parceiros/alterar/:id",
    name: "parceirosAlterar",
    component: ParceirosCadastro,
  },

  {
    path: "/vouchers",
    name: "Vouchers",
    component: VouchersIndex,
  },
  {
    path: "/vouchers/cadastro/:id?",
    name: "vouchersCadastro",
    component: VouchersCadastro,
  },

  {
    path: "/permissoes",
    name: "Permissoes",
    component: PermissoesIndex,
  },

  {
    path: "/logs",
    name: "Logs",
    component: LogsIndex,
  },

  {
    path: "/versoes",
    name: "Versoes",
    component: VersoesIndex,
  },

  {
    path: "/contratos",
    name: "contratos",
    component: Contratos,
  },
  {
    path: "/contratos/cadastro/:id?",
    name: "contratosCadastro",
    component: ContratosCadastro,
  },
  {
    path: "/contratos/ver/:id",
    name: "contratosVer",
    component: ContratosVer,
  },
  {
    path: "/contratos/assinar/:id",
    name: "contratosAssinar",
    component: ContratosAssinar,
  },
  {
    path: "/contasReceber/:id?",
    name: "contasReceber",
    component: ContasReceber
  },
  {
    path: "/parametros",
    name: "parametros",
    component: ParametrosIndex,
  },
  {
    path: "/parametros/cadastro",
    name: "parametrosCadastro",
    component: ParametrosCadastro,
  },
  {
    path: "/parametros/cadastro/:id",
    name: "parametrosCadastro",
    component: ParametrosCadastro,
  },
  {
    path: "/boletosRetornos",
    name: "boletosRetornos",
    component: Retornos,
  },
  {
    path: "/boletosRetornosItens/:id",
    name: "boletosRetornosItens",
    component: RetornoItens,
  },
  {
    path: "/boletosRetornosDiferencas/:id",
    name: "boletosRetornosDiferencas",
    component: RetornoDiferencas,
  },
  {
    path: "/boletos/importarRelatorioBanco",
    name: "boletosImportarRelatorioBanco",
    component: BoletosImportarRelatorioBanco,
  },
  {
    path: "/boletos",
    name: "Manutenção de Boletos",
    component: Boletos,
  },
  {
    path: "/boletosRemessas",
    name: "boletosRemessas",
    component: BoletosRemessas,
  },
  {
    path: "/boletos/consultarBanco",
    name: "boletosConsultarBanco",
    component: BoletosConsultarBanco,
  },

  {
    path: "/",
    name: "EcommercePage",
    component: EcommercePage,
  },

  {
    path: "/login",
    name: "LoginPage",
    component: LoginPage,
  },
  {
    path: "/register",
    name: "RegisterPage",
    component: RegisterPage,
  },
  {
    path: "/forgot-password",
    name: "ForgotPasswordPage",
    component: ForgotPasswordPage,
  },
  {
    path: "/reset-password",
    name: "ResetPasswordPage",
    component: ResetPasswordPage,
  },
  {
    path: "/email-confirmation",
    name: "EmailConfirmationPage",
    component: EmailConfirmationPage,
  },


  {
    path: "/logout",
    name: "LogoutPage",
    component: LogoutPage,
  },

    {
    path: "/relatorios/mensalidades",
    name: "RelMensalidades",
    component: RelMensalidades,
  },
  {
    path: "/relatorios/clientes",
    name: "RelClientes",
    component: RelClientes,
  },

  {
    path: "/relatorios/clientescontrato",
    name: "RelClientesContrato",
    component: RelClientesContrato,
  },

  {
    path: "/relatorios/clientesdependentes",
    name: "RelClientesDependentes",
    component: RelClientesDependentes,
  },

  {
    path: "/cliente",
    name: "PainelCliente",
    component: PainelCliente,
  },
  {
    path: "/cliente/login",
    name: "PainelClienteLogin",
    component: PainelClienteLogin,
  },

  {
    path: "/cliente",
    name: "PainelCliente",
    component: PainelCliente,
  },
  {
    path: "/cliente/parceiro/:parceiroId",
    name: "PainelClienteParceiro",
    component: PainelClienteParceiro,
  },
    {
    path: "/cliente/verContrato/:contratoId",
    name: "PainelClienteVerContrato",
    component: PainelClienteVerContrato,
  },
  {
    path: "/cliente/assinarContrato/:contratoId",
    name: "PainelClienteAssinarContrato",
    component: PainelClienteAssinarContrato,
  },

  { path: '/:catchAll(.*)', component: ErrorPage } // Rota 404

];

const router = createRouter({
  history: createWebHistory(),
  linkExactActiveClass: "active",
  routes: routes,
  scrollBehavior() {
    return { top: 0, behavior: "smooth" };
  },
});

router.beforeEach((to, from, next) => {
  const paginasPublicas = ["/login","/cliente","/cliente/login"];
  const requerLogin = !paginasPublicas.includes(to.path);

  const logado = localStorage.getItem("user");

  if (to.path.startsWith("/validador/")) {
    return next();
  }

  if ( to.path === "/cliente/login") {
    return next();
  }

  if (to.path === "/cliente" ) {
    const clienteToken = localStorage.getItem("clienteToken");
    
    if (clienteToken != null && clienteToken !== "")
    {
      return next();
    }
    else
    {
      return next("/cliente/login");
    }
  }

  // trying to access a restricted page + not logged in
  // redirect to login page
  if (requerLogin && !logado) {
    console.log("Usuário não logado.");
    next("/login");
  } else {
    next();
  }
});

export default router;